import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plan = {
  name: '📘 100+ AI PROMPTS FOR 911 DISPATCHERS™',
  ideal: '911 Dispatchers, Public Safety Telecommunicators, Call-Takers, CTOs and Comm-Center Supervisors who want to finish their paperwork before shift change.',
  was: '$54',
  now: '27',
  features: ['Full 6-Volume Toolkit', '120 complete, copy-and-paste AI prompts', 'Works with ChatGPT, Claude and Gemini', '4 Free Bonuses included', 'Instant PDF access', '7-Day Money-Back Guarantee', '♾️ Lifetime Access'],
  cta: 'Get the 100+ AI Prompts now'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Phone & Desktop'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-115" data-mp="3vzgrvnxml0wr">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-116" data-mp="4smfitxh0a0d">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-117" data-mp="9tjwx4anp00t">
          <p className="font-display text-xl font-black text-plum" data-id="element-118" data-mp="er1trwbefosg">📦 The complete toolkit, 50% off its listed value</p>
          <p className="mt-2 text-sm font-semibold text-plum/70" data-id="element-119" data-mp="3d9qoicfsr6t8">
            One payment. No subscription. Yours to keep.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center overflow-hidden rounded-3xl border border-grape/30 bg-white px-6 pb-6 text-center shadow-[0_24px_60px_-28px_rgba(11,31,58,0.5)]" data-id="element-120" data-mp="3i5xxke3hoyfe">
          <div className="-mx-6 mb-5 w-[calc(100%+3rem)] bg-plum px-6 py-3" data-id="element-121" data-mp="2rfa79tyxonii">
            <h3 className="font-display text-base font-black text-white" data-id="element-122" data-mp="2mgqk5q8lt5ok">{plan.name}</h3>
          </div>
          <p className="text-sm text-plum/60" data-id="element-123" data-mp="315mqniv0ian2">
            <span className="font-semibold text-plum/80" data-id="element-124" data-mp="318ipd9eop3ck">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-125" data-mp="28i0li664yxy3">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-126" data-mp="28h7csznm9ydb">{plan.was}</span>
            <div className="flex w-full justify-center py-2" data-id="element-127" data-mp="23jpc1wjr6pge">
              <span className="relative inline-block font-display leading-none" data-id="element-128" data-mp="23la6zn9zcaes">
                <span className="absolute right-full top-1/2 mr-2 -translate-y-1/2 text-[45px] font-black leading-none text-grape" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-129" data-mp="2ie3m37lcaoix">
                  $
                </span>
                <span className="text-grape-shine text-[74px] font-black leading-none" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-130" data-mp="3ow8x55pdbmuy">
                  {plan.now}
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-131" data-mp="59zzr4amzhtx">
              · One-time payment · Lifetime Access ·
            </p>
            <p className="mt-1 text-center text-[11px] font-medium text-plum/55" data-id="element-132" data-mp="3ngo0khynlits">
              · Payment will be processed in your local currency ·
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-133" data-mp="j1wnkw59v5ki">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-134" data-mp="o07wn4nqtc1o">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-135" data-mp="a933mlevri0b" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-136" data-mp="e8ll177htaye">
            <CTAButton size="md" data-id="element-137" data-mp="11zhbo107q042">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[12px] font-bold text-blush" data-id="element-138" data-mp="16qft53wxt48w">
            Save $27 (50% Off)
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-139" data-mp="3f78ukk8dfpic">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-140" data-mp="3592rw0eqqfcf">
                <Icon className="h-4 w-4 text-grape" data-id="element-141" data-mp="35b5s1d9lxouv" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-142" data-mp="1t5ivusbfdfo">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-143" data-mp="3szozxroqvzmf" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-144" data-mp="3o75ds6bzrw60">
            <span className="font-display font-bold text-plum" data-id="element-145" data-mp="3k6v9cy3uldt9">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel this toolkit does not make your paperwork faster and
            clearer, just ask for a refund and we will return your money. No complicated steps.
          </p>
        </div>
      </div>
    </section>;
}